import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AccessControl,
  NavigationLoading,
  getTranslatedText,
  useCheckFeatureGating
} from '@nile/components';
import shortid from 'shortid';
import { SVGIcon } from '@superops/super-icons';
import { NavLink, withRouter } from 'react-router-dom';
import { getEmoji } from '@nile/reports/src/modules/home/components/utils';
import {
  Button,
  DisplayText,
  TextStyle,
  Tippy
} from '@superops/ui-design-system';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { isEmpty, noop } from 'lodash';

const NoDataImage = () => {
  return (
    <div className="fx jctr actr ignoreOverride">
      <SVGIcon name="NotFound" size="sm" />
    </div>
  );
};

function Section(props) {
  const {
    showCreateBtn,
    isLocalised = false,
    waitForLoading = false,
    showConfiguration = false,
    onConfigurationClick,
    loading,
    onNavClick = () => {},
    title,
    intl,
    onCreate = () => {},
    data = [],
    addToolTip,
    checkReportAccessiable = false,
    featureLocked = noop
  } = props;

  return (
    <>
      <div className="fx mbt5 plr-8">
        <div className="flex actr fx2 uppercase">
          <DisplayText weight="SemiBold">
            <TextStyle variation="subdued">
              <FormattedMessage id={title} />
            </TextStyle>
          </DisplayText>
        </div>
        {showConfiguration && (
          <div className="flex actr mr8">
            <Button
              plain
              monochrome
              onClick={() => onConfigurationClick()}
              icon={<SVGIcon name="SettingsDark" size="sm" />}
              size="tiny"
            />
          </div>
        )}
        {showCreateBtn && (
          <AccessControl
            roleToCheck="report.add"
            render={
              <>
                <div
                  className="fx ptr"
                  onClick={onCreate}
                  title={getTranslatedText(intl, addToolTip)}
                >
                  <SVGIcon name="Add" color="#00000066" />
                </div>
              </>
            }
          />
        )}
      </div>

      <span className="divider mb10" />

      {loading ? (
        <NavigationLoading rows={2} />
      ) : (
        <>
          <div className="mb20">
            {data?.map((item) => {
              const reportLocked =
                checkReportAccessiable && !featureLocked(item?.internalName);

              return (
                <>
                  <NavLink
                    className={`${
                      waitForLoading ? 'cursor-not-allowed' : ''
                    } navLink`}
                    strict
                    key={shortid.generate()}
                    replace
                    onClick={() => onNavClick(item)}
                    to={!waitForLoading && item?.url}
                  >
                    <Tippy
                      title={
                        isLocalised
                          ? getTranslatedText(intl, dompurifier(item.name))
                          : dompurifier(item.name)
                      }
                      position="bottom-end"
                      delay={500}
                    >
                      <div className="fx actr justify-between">
                        <div className="fx actr lh-18">
                          {getEmoji(item)}
                          {isLocalised ? (
                            <FormattedMessage id={item.name} />
                          ) : (
                            item.name
                          )}
                        </div>
                        {item?.fullScreenModeEnabled && (
                          <div>
                            <SVGIcon name="SmartTV" />
                          </div>
                        )}
                        {reportLocked && (
                          <div>
                            <SVGIcon name="Lock" />
                          </div>
                        )}
                      </div>
                    </Tippy>
                  </NavLink>
                </>
              );
            })}
          </div>
          {!data?.length && <NoDataImage />}
        </>
      )}
    </>
  );
}

export default withRouter(Section);
